const maskCardNumber = (cardNumber: string | undefined) => {
  if (cardNumber === undefined) return undefined;

  if (cardNumber.length < 13) return cardNumber;
  const masked = `• • • • • • • • • • • • ${cardNumber.slice(-4)}`;
  return masked;
};

export default maskCardNumber;
